module.exports = __webpack_public_path__ + "static/media/img-cropper.a2ff611f.jpg";